<div class="app-container">

  <div class="app-nav d-none d-md-block">
    <app-sidebar></app-sidebar>
  </div>

  <div class="app-content">

    <div class="app-content-topbar">
      <app-topbar class="d-block d-md-none" [language]="loc.language"></app-topbar>
      <app-view-topbar></app-view-topbar>
    </div>

    <div class="app-content-main">
      <main>
        <router-outlet #outlet></router-outlet>
      </main>
    </div>

    <app-footer [language]="loc.language"></app-footer>

  </div>

</div>

<app-candidate-chats [language]="loc.language"></app-candidate-chats>
